/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: apollo client.


/*
 * EXPORTS
 */
export default gql`
  query VendorAccountConnectedQuery(
    $isActive: Boolean!
    $take: PositiveInt
    $skip: Int
    $filter: JSONObject
  ) {
    VendorAccountConnected(isActive: $isActive, take: $take, skip: $skip, filter: $filter) {
      id
      _totalCount
      displayName
      message
      status
      Smpp {
        id
        ip
        isActive
        mode
      }
    }
  }
`;
